app.factory("medicalNormalRangeService", function() {
    //総コレストロール　正常値判定
    function medicalTCNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(130<=value && value<=220) {
                rs = true;
            }
        }
        else {
            //女性
            if(130<=value && value<=220) {
                rs = true;
            }
        }
        return rs;
    };
    //体脂脂肪率　正常値判定
    function medicalFatNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(value<=20) {
                rs = true;
            }
        }
        else {
            //女性
            if(value<=30) {
                rs = true;
            }
        }
        return rs;
    };
    //体脂脂肪率　正常値判定
    function medicalBMINormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(18.5<=value && value<=24.9) {
                rs = true;
            }
        }
        else {
            //女性
            if(18.5<=value && value<=24.9) {
                rs = true;
            }
        }
        return rs;
    };
    //腹囲正常値判定
    function medicalWaistNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(value<=85) {
                rs = true;
            }
        }
        else {
            //女性
            if(value<=90) {
                rs = true;
            }
        }
        return rs;
    };
    //血圧最高正常値判定
    function medicalSystolicNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(value<=129) {
                rs = true;
            }
        }
        else {
            //女性
            if(value<=129) {
                rs = true;
            }
        }
        return rs;
    };
    //血圧最低正常値判定
    function medicalDiastolicNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(value<=84) {
                rs = true;
            }
        }
        else {
            //女性
            if(value<=84) {
                rs = true;
            }
        }
        return rs;
    };
    //血圧脈拍正常値判定
    function medicalPulseNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(60<=value && value<=100) {
                rs = true;
            }
        }
        else {
            //女性
            if(60<=value && value<=100) {
                rs = true;
            }
        }
        return rs;
    };
    //白血球正常値判定
    function medicalWBCNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(4.8<=value && value<=8.0) {
                rs = true;
            }
        }
        else {
            //女性
            if(4.8<=value && value<=8.0) {
                rs = true;
            }
        }
        return rs;
    };
    //赤白血球正常値判定
    function medicalRBCNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(410<=value && value<=540) {
                rs = true;
            }
        }
        else {
            //女性
            if(380<=value && value<=500) {
                rs = true;
            }
        }
        return rs;
    };
    //血小板数正常値判定
    function medicalPltNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(12.0<=value && value<=40.0) {
                rs = true;
            }
        }
        else {
            //女性
            if(12.0<=value && value<=40.0) {
                rs = true;
            }
        }
        return rs;
    };
    //ヘモグロビン正常値判定
    function medicalHbNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(13.1<=value) {
                rs = true;
            }
        }
        else {
            //女性
            if(12.1<=value) {
                rs = true;
            }
        }
        return rs;
    };
    //ヘマトクリット正常値判定
    function medicalHtNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(39.0<=value && value<=50.0) {
                rs = true;
            }
        }
        else {
            //女性
            if(36.0<=value && value<=48.0) {
                rs = true;
            }
        }
        return rs;
    };
    //コレステロール正常値判定
    function medicalTCNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(130<=value && value<=220) {
                rs = true;
            }
        }
        else {
            //女性
            if(130<=value && value<=220) {
                rs = true;
            }
        }
        return rs;
    };
    //HDLコレステロール正常値判定
    function medicalHDLNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(40<=value) {
                rs = true;
            }
        }
        else {
            //女性
            if(40<=value) {
                rs = true;
            }
        }
        return rs;
    };
    //LDLコレステロール正常値判定
    function medicalLDLNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(value<=119) {
                rs = true;
            }
        }
        else {
            //女性
            if(value<=119) {
                rs = true;
            }
        }
        return rs;
    };
    //中性脂肪正常値判定
    function medicalTGNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(value<=149) {
                rs = true;
            }
        }
        else {
            //女性
            if(value<=149) {
                rs = true;
            }
        }
        return rs;
    };
    //空腹時血唐正常値判定
    function medicalTGNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(value<=99) {
                rs = true;
            }
        }
        else {
            //女性
            if(value<=99) {
                rs = true;
            }
        }
        return rs;
    };
    //HbA1c正常値判定
    function medicalHbA1cNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(value<=5.5) {
                rs = true;
            }
        }
        else {
            //女性
            if(value<=5.5) {
                rs = true;
            }
        }
        return rs;
    };
    //AST・GOT正常値判定
    function medicalGOTNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(value<=30) {
                rs = true;
            }
        }
        else {
            //女性
            if(value<=30) {
                rs = true;
            }
        }
        return rs;
    };
    //ALT・GPT正常値判定
    function medicalGPTNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(value<=30) {
                rs = true;
            }
        }
        else {
            //女性
            if(value<=30) {
                rs = true;
            }
        }
        return rs;
    };
    //γ-GTP正常値判定
    function medicalGTPNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(value<=50) {
                rs = true;
            }
        }
        else {
            //女性
            if(value<=50) {
                rs = true;
            }
        }
        return rs;
    };
    //ALP正常値判定
    function medicalALPNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(105<=value && value<=330) {
                rs = true;
            }
        }
        else {
            //女性
            if(105<=value && value<=330) {
                rs = true;
            }
        }
        return rs;
    };
    //LDH正常値判定
    function medicalLDHNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(120<=value && value<=245) {
                rs = true;
            }
        }
        else {
            //女性
            if(120<=value && value<=245) {
                rs = true;
            }
        }
        return rs;
    };
    //尿素窒素正常値判定
    function medicalBUNNormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(8<=value && value<=20) {
                rs = true;
            }
        }
        else {
            //女性
            if(8<=value && value<=20) {
                rs = true;
            }
        }
        return rs;
    };
    //クレアニチン正常値判定
    function medicalCRENormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(0.66<=value && value<=1.11) {
                rs = true;
            }
        }
        else {
            //女性
            if(0.50<=value && value<=0.86) {
                rs = true;
            }
        }
        return rs;
    };
    //尿酸正常値判定
    function medicalUANormalRange(gender, value) {
        var rs = false;
        if(gender == 0) {
            //男性
            if(1.5<=value && value<=7.0) {
                rs = true;
            }
        }
        else {
            //女性
            if(1.5<=value && value<=7.0) {
                rs = true;
            }
        }
        return rs;
    };
    return {
        medicalNormalRange : function(gender, type, value) {
            try {
                var rs = eval(type+"NormalRange("+gender+","+value+")");
            }
            catch(e) {
                rs = true;
            }
            return rs;
        }
	};
});
